const badgeBase =
  'inline-flex items-center rounded-full px-2 py-0.5 text-[10px] font-bold uppercase tracking-wide';

const ActivitySafetyBadges = ({ activity, creator }) => {
  const items = [];

  if (activity.allowedGender === 'male') {
    items.push({ key: 'boys', label: 'Only Boys', className: 'bg-gradient-to-r from-sky-500/90 to-blue-600/90 text-white' });
  } else if (activity.allowedGender === 'female') {
    items.push({ key: 'girls', label: 'Only Girls', className: 'bg-gradient-to-r from-fuchsia-500/90 to-pink-600/90 text-white' });
  } else {
    items.push({ key: 'mixed', label: 'Open to All', className: 'bg-gradient-to-r from-violet-500/90 to-purple-600/90 text-white' });
  }

  if (activity.verifiedOnly === true) {
    items.push({
      key: 'vo',
      label: 'Verified only',
      className: 'bg-gradient-to-r from-emerald-500/90 to-teal-600/90 text-white',
    });
  }

  const host = creator || activity.creator;
  if (host?.faceVerified) {
    items.push({
      key: 'host',
      label: 'Verified host',
      className: 'bg-gradient-to-r from-amber-500/90 to-orange-600/90 text-white',
    });
  }

  if (items.length === 0) return null;

  return (
    <div className="flex flex-wrap gap-1">
      {items.map(({ key, label, className }) => (
        <span key={key} className={`${badgeBase} ${className}`}>
          {label}
        </span>
      ))}
    </div>
  );
};

export default ActivitySafetyBadges;
